import ToolbarTitle from "design/components/texts/ToolbarTitle";
import Tabs from "design/components/toolbar/Tabs";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import Center from "design/layouts/Center";
import SplitView from "design/layouts/SplitView";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import { getFileApiURL } from "qpr-base/utils/url-utils";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import { t } from "i18next";

type Props = { selected?: string };

const useIconStyles = makeThemedStyles("WorkflowToolbarIcon", (theme) => ({
  root: {
    marginLeft: 0,
    marginRight: "15px",
    marginTop: 0,
    width: "50px",
    height: "50px",
    backgroundImage: `url(${getFileApiURL(`/icons/navitems/workflows.svg`)})`,
  },
}));

const WorkflowToolbar = (props: Props) => {
  const ctx = useAppContext();
  const link = useLink();
  const iconstyles = useIconStyles();
  return (
    <ToolbarContainer>
      <SplitView partCnt={3}>
        <ToolbarTitle>
          <span className={iconstyles.root}></span>
          {ctx.page === "mytasks"
            ? t("toolbar.My Tasks")
            : ctx.page === "workflowinput"
            ? t("toolbar.Value Input")
            : t("toolbar.Completed Tasks")}
        </ToolbarTitle>
        <Center>
          <Tabs
            onChange={(value) => {
              link({
                page: value,
              });
            }}
            selected={props.selected || ctx.page || ""}
            options={[
              {
                viewName: "mytasks",
                title: "toolbar.My Tasks",
              },
              {
                viewName: "workflowinput",
                title: "toolbar.Actions",
              },
              {
                viewName: "completedtasks",
                title: "toolbar.Completed Tasks",
              },
            ]}
          />
        </Center>
      </SplitView>
    </ToolbarContainer>
  );
};

export default WorkflowToolbar;
